"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPROVAL_MAX_FIELDS = exports.DEXT_FIELDS = exports.XERO_FIELDS = void 0;
// 'Organisation Name', 'Price Plan', 'Charge Type', 'Billing Start Date', 'Billing End Date', 'Details', 'Total', 'Client Code', 'DiscountCategory'
exports.XERO_FIELDS = ['Organisation Name', 'Price Plan', 'Billing Start Date', 'Billing End Date', 'Details', 'Total', 'DiscountCategory'];
// 'Client', 'Practice code', 'Items Extracted', 'Bank Statement Extraction (Sheets)', 'Line Item Extraction (Documents)', 'Boost (Clicks)'
exports.DEXT_FIELDS = ['Client', 'Items Extracted'];
// 'Organisation name', 'Plan', 'Short code', 'Connection status', 'Net charge', 'Currency', 'Client reference', 'Practice reference'
exports.APPROVAL_MAX_FIELDS = ['Organisation name', 'Plan'];
